import { Link } from "gatsby";
import * as React from "react";

import styled from "@emotion/styled";
import { breakpoints } from "../styles/breakpoints";
import { ArrowButton } from "./arrow-button";

const StyledFeatureSmall = styled.div`
  margin-top: var(--medium);
  padding: var(--small);
  background: var(--off-white);
  box-shadow: var(--shadow-normal);
  border-radius: 0.7rem;
  max-width: 31rem;

  @media (max-width: ${breakpoints.lg}) {
    padding: var(--x-small) var(--small);
    max-width: 40rem;
  }

  @media (max-width: ${breakpoints.md}) {
    width: 100%;
  }

  @media (max-width: ${breakpoints.sm}) {
    max-width: 45rem;
  }

  h3 {
    margin: 0 auto var(--xx-small);
    max-width: 18rem;

    @media (${breakpoints.lg}) {
      max-width: 13rem;
    }
  }

  .img {
    display: block;
    margin: auto;
    max-height: 15rem;
  }

  a {
    margin-top: var(--x-small);
  }
`;

export interface FeatureSmallProps {
  title: string;
  image: string;
  text?: string;
  link?: {
    href: string;
    text?: string;
  };
}

export const FeatureSmall = ({
  title,
  image,
  text,
  link,
}: FeatureSmallProps) => (
  <StyledFeatureSmall>
    <Link to={link.href}>
      <h3 className="h3">{title}</h3>
    </Link>
    {text ? <p>{text}</p> : null}
    <img src={image} alt={title} className="img" />
    {link ? (
      <ArrowButton
        href={link.href}
        text={link.text ? link.text : "Learn more"}
      />
    ) : null}
  </StyledFeatureSmall>
);
